export const EXPERIENCE = {
  ECP: 'ecp',
  SMB: 'smb',
  POST_OOBE: 'DeviceSelectedForPostOobePrinterClaim',
} as const

export const PRODUCT_FAMILY = {
  LFP: 'LFP_DUNE',
} as const

export const ENTRY = {
  STARTSCAN: 'portalScanSetup',
  SMALLVILLE: 'earlyOobe',
  PORTAL_OOBE: 'portalOobe',
} as const

export const ENTRY_PATH = {
  STARTSCAN: '/startscan',
  ACTIVATE: '/activate',
  CONNECT: '/connect',
  GO: '/go',
  PN: '/pn',
} as const

export const BIZ_MODEL_HINT = {
  E2E: 'E2E',
  FLEX: 'Flex',
} as const

export const PROGRAM_LEVEL = {
  STANDARD: 'UCDE',
  UCDE_PLUS: 'UCDEplus',
  HP_PLUS: 'YETI',
} as const
